import { AlertTriangle } from "lucide-react";
import type { LucideIcon } from "lucide-react";

interface AlertProps {
  variant: "error" | "warning";
  message: string;
  icon?: LucideIcon;
}

const variantStyles = {
  error: {
    container: "border-[#FEE2E2] bg-[#FEF2F2]",
    content: "text-[#DC2626]",
  },
  warning: {
    container: "border-none bg-[#FFF7E6]",
    content: "text-[#D97706]",
  },
};

export function Alert({ variant, message, icon: Icon }: AlertProps) {
  const styles = variantStyles[variant];
  const DefaultIcon = variant === "error" ? AlertTriangle : null;
  const ResolvedIcon = Icon ?? DefaultIcon;

  return (
    <div
      className={`flex items-center gap-2 rounded-lg border px-4 py-3 ${styles.container}`}
    >
      {ResolvedIcon && (
        <ResolvedIcon
          className={`size-3.5 shrink-0 ${styles.content}`}
          strokeWidth={2}
        />
      )}
      <span className={`text-[13px] font-medium ${styles.content}`}>
        {message}
      </span>
    </div>
  );
}
